"use strict";
/// <reference path='Chart.d.ts' />
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chart = exports.AxisType = exports.ChartType = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
const ej2_charts_1 = require("@syncfusion/ej2-charts");
const ej2_circulargauge_1 = require("@syncfusion/ej2-circulargauge");
const ej2_base_1 = require("@syncfusion/ej2-base");
const EJ2_LOCALE = require("../../../node_modules/@syncfusion/ej2-locale/src/de.json");
const $ = require("jquery");
const Utilities_1 = require("../../javascript/Utilities");
require("./Chart.less");
const n1 = require("../../../node_modules/cldr-data/main/de/currencies.json");
const n2 = require("../../../node_modules/cldr-data/main/de/timeZoneNames.json");
const n3 = require("../../../node_modules/cldr-data/main/de/numbers.json");
const n4 = require("../../../node_modules/cldr-data/main/de/ca-gregorian.json");
const s = require("../../../node_modules/cldr-data/supplemental/currencyData.json");
const s2 = require("../../../node_modules/cldr-data/supplemental/numberingSystems.json");
ej2_charts_1.AccumulationChart.Inject(ej2_charts_1.AccumulationChart, ej2_charts_1.AccumulationLegend, ej2_charts_1.PieSeries, ej2_charts_1.PyramidSeries, ej2_charts_1.AccumulationDataLabel, ej2_charts_1.AccumulationTooltip, ej2_charts_1.DataLabel, ej2_charts_1.Export);
ej2_charts_1.Chart.Inject(ej2_charts_1.ScatterSeries, ej2_charts_1.LineSeries, ej2_charts_1.Category, ej2_charts_1.DateTime, ej2_charts_1.DataLabel, ej2_charts_1.Legend, ej2_charts_1.Crosshair, ej2_charts_1.Tooltip, ej2_charts_1.Selection, ej2_charts_1.Zoom, ej2_charts_1.ColumnSeries, ej2_charts_1.BarSeries, ej2_charts_1.StackingBarSeries, ej2_charts_1.AreaSeries, ej2_charts_1.StackingAreaSeries, ej2_charts_1.RangeColumnSeries, ej2_charts_1.StackingColumnSeries, ej2_charts_1.Export);
ej2_circulargauge_1.CircularGauge.Inject(ej2_circulargauge_1.CircularGauge, ej2_circulargauge_1.Legend, ej2_circulargauge_1.GaugeTooltip, ej2_circulargauge_1.Annotations);
ej2_base_1.loadCldr(n1, n2, n3, n4, s, s2);
ej2_base_1.L10n.load({ de: EJ2_LOCALE.de });
ej2_base_1.setCulture('de');
ej2_base_1.setCurrencyCode('EUR');
/**
 * Chart types
 */
var ChartType;
(function (ChartType) {
    ChartType[ChartType["Line"] = 1] = "Line";
    ChartType[ChartType["Bar"] = 2] = "Bar";
    ChartType[ChartType["StackingBar"] = 3] = "StackingBar";
    ChartType[ChartType["StackingBar100"] = 4] = "StackingBar100";
    ChartType[ChartType["Area"] = 5] = "Area";
    ChartType[ChartType["StackingArea"] = 6] = "StackingArea";
    ChartType[ChartType["StackingArea100"] = 7] = "StackingArea100";
    ChartType[ChartType["Column"] = 8] = "Column";
    ChartType[ChartType["RangeColumn"] = 9] = "RangeColumn";
    ChartType[ChartType["StackingColumn"] = 10] = "StackingColumn";
    ChartType[ChartType["StackingColumn100"] = 11] = "StackingColumn100";
    ChartType[ChartType["Pie"] = 12] = "Pie";
    ChartType[ChartType["Pyramid"] = 13] = "Pyramid";
    ChartType[ChartType["Gauge"] = 14] = "Gauge";
    ChartType[ChartType["Table"] = 15] = "Table";
    ChartType[ChartType["Scatter"] = 16] = "Scatter";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
/**
 * Axis types
 */
var AxisType;
(function (AxisType) {
    AxisType[AxisType["DateTime"] = 1] = "DateTime";
    AxisType[AxisType["Double"] = 2] = "Double";
    AxisType[AxisType["Category"] = 3] = "Category";
})(AxisType = exports.AxisType || (exports.AxisType = {}));
/**
 * Chart implementation
 */
class Chart {
    static init($elem, chartId, filterOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return $elem.each(function () {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    yield Chart.fetchChartDataAsync($elem, chartId, false, filterOptions).then(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        const synData = $elem.data('synChart');
                        const $this = $(this);
                        $this.trigger('beginInit');
                        if (synData.Filter.UserFilterColumn && filterOptions && filterOptions.DefaultUserFilterValue && $.inArray(filterOptions.DefaultUserFilterValue, synData.state.DistinctFieldValues) === -1)
                            yield Chart.createEmptyChartAsync($elem);
                        else if (synData.ChartType === ChartType.Gauge)
                            yield Chart.createGaugeChartAsync($elem);
                        else if (synData.ChartType === ChartType.Pie || synData.ChartType === ChartType.Pyramid)
                            yield Chart.createAccuChartAsync($elem);
                        else if (synData.ChartType === ChartType.Table)
                            yield Chart.createTableChartAsync($elem);
                        else
                            yield Chart.createChartAsync($elem);
                        $this.trigger('initSuccess');
                        $this.trigger('endInit');
                    }));
                });
            });
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            const $this = $(this);
            $this.removeData('synChart');
            $this.children().remove();
            // $this.off('beginInit initSuccess initFailed endInit');
            $this.html('');
        });
    }
    static recreate($elem) {
        return $elem.each(function () {
            const synData = $elem.data('synChart');
            $elem.synChart('destroy');
            if (synData.Filter.UserFilterColumn && synData.Filter.DefaultUserFilterValue && $.inArray(synData.Filter.DefaultUserFilterValue, synData.state.DistinctFieldValues) === -1)
                Chart.createEmptyChartAsync($elem);
            else if (synData.ChartType === ChartType.Gauge)
                Chart.createGaugeChartAsync($elem);
            else if (synData.ChartType === ChartType.Pie || synData.ChartType === ChartType.Pyramid)
                Chart.createAccuChartAsync($elem);
            else if (synData.ChartType === ChartType.Table)
                Chart.createTableChartAsync($elem);
            else
                Chart.createChartAsync($elem);
        });
    }
    static getChartOptions($elem) {
        const synData = $elem.data('synChart');
        return synData.Options;
    }
    static getChartFilter($elem) {
        const synData = $elem.data('synChart');
        return synData.Filter;
    }
    static getDistinctFieldValues($elem) {
        const synData = $elem.data('synChart');
        return synData.Filter.DistinctFieldValues;
    }
    //#region Helpers
    static createGaugeChartAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Chart.applyFilterAsync($elem).then(() => {
                const synData = $elem.data('synChart');
                // gauge recieves value of undefined -> get empty chart
                if (synData.Gauge.Value == undefined)
                    return Chart.createEmptyChartAsync($elem);
                let chart = new ej2_circulargauge_1.CircularGauge(({
                    tooltip: { enable: synData.Options.Tooltip, textStyle: { fontFamily: 'Arial', size: '25px' } },
                    margin: { left: 10, right: 30, top: 50, bottom: 30 },
                    locale: 'de-AT',
                    useGroupingSeparator: true,
                    axes: [{
                            lineStyle: { width: 10, color: 'transparent' },
                            startAngle: 195,
                            endAngle: 165,
                            direction: 'ClockWise',
                            minimum: synData.Gauge.Minimum,
                            maximum: synData.Gauge.Maximum,
                            majorTicks: { useRangeColor: false, position: 'Outside' },
                            minorTicks: { useRangeColor: false, position: 'Outside' },
                            labelStyle: { useRangeColor: false, position: 'Outside', font: { size: '25px', fontFamily: 'Arial' } },
                            ranges: Chart.getRanges($elem),
                            radius: (synData.Gauge.RadiusInPercent && synData.Gauge.RadiusInPercent >= 50) ? synData.Gauge.RadiusInPercent.toString() + '%' : '100%',
                            pointers: [
                                { value: synData.Gauge.Value, animation: { enable: true, duration: 1000 }, type: 'Needle', needleTail: { length: '0%' } }
                            ],
                            annotations: [
                                { content: synData.Options.DataLabel ? synData.Gauge.Value.toString() : '', zIndex: '1', radius: '0%', textStyle: { size: '25px', fontWeight: 'bold' } }
                            ],
                        }],
                    legendSettings: { visible: synData.Options.HideLegend ? false : true, alignment: 'Center', padding: 10, textStyle: { size: '25px', fontFamily: 'Arial' }, position: 'Left' }
                }));
                Chart.createHeader($elem);
                chart.appendTo($elem[0]);
                if (synData.HelpText)
                    Chart.createHelpText($elem);
                if (synData.Options.Printable)
                    Chart.createPrintButton($elem, chart);
                if (synData.Filter.UserFilterColumn && synData.Filter.HideFilterButton === false)
                    Chart.createFilterButton($elem, Chart.createTableChartAsync);
                return Promise.resolve();
            });
        });
    }
    static createAccuChartAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Chart.applyFilterAsync($elem).then(() => {
                const synData = $elem.data('synChart');
                let chartSeries = Chart.createSeries($elem);
                let chart = new ej2_charts_1.AccumulationChart({
                    series: chartSeries,
                    enableSmartLabels: true,
                    enableExport: synData.Options.Printable,
                    legendSettings: { visible: synData.Options.HideLegend ? false : true, shapeHeight: 20, padding: 10, textStyle: { size: '25px', fontFamily: 'Arial' } },
                    enableAnimation: true,
                    title: Chart.getlabelWithFilter($elem),
                    locale: 'de-AT',
                    subTitle: synData.SubLabel,
                    tooltip: { enable: synData.Options.Tooltip, textStyle: { fontFamily: 'Arial', size: '25px' } },
                    titleStyle: { size: '24px', fontFamily: 'Arial' },
                    subTitleStyle: { size: '24px', fontFamily: 'Arial' },
                    useGroupingSeparator: true,
                    pointRender: (args) => {
                        if (synData.Groups && synData.Groups[args.point.x])
                            args.fill = synData.Groups[args.point.x].Color;
                    },
                });
                Chart.createHeader($elem);
                chart.appendTo($elem[0]);
                if (synData.HelpText)
                    Chart.createHelpText($elem);
                if (synData.Options.Printable)
                    Chart.createPrintButton($elem, chart);
                if (synData.Filter.UserFilterColumn && synData.Filter.HideFilterButton === false)
                    Chart.createFilterButton($elem, Chart.createTableChartAsync);
                if (synData.state.isFiltered)
                    chart.title = chart.title + ' ' + synData.state.filterValue;
                return Promise.resolve();
            });
        });
    }
    static createTableChartAsync($elem, oldChartData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (oldChartData)
                $elem.data('synChart', $.extend({}, oldChartData));
            yield Chart.applyFilterAsync($elem).then(() => {
                const synData = $elem.data('synChart');
                let label = synData.chartId.replace(/\|/g, '_');
                if (synData.state.isFiltered)
                    label += ' ' + synData.state.filterValue;
                let chartSeries = Chart.createSeries($elem);
                let $table = $('<div />')
                    .attr({
                    'id': 'table_' + label,
                    'data-tableid': label,
                    'class': 'tablechart',
                    'style': 'height: calc(100% - 35px); border-bottom-left-radius: inherit; border-bottom-right-radius: inherit; background-color: white; fontFamily: Arial; font-size: 18px;'
                })
                    .on('click', (event) => {
                    event.preventDefault();
                });
                let table = '<table style="padding: 0px; height: calc(100% - 25px);" ><tr><td style="font-weight: bold; background: #8bbb80">' + synData.AxisLabels[1] + '</td>';
                let columns = [];
                for (let key in chartSeries)
                    for (let dsKey in chartSeries[key].dataSource)
                        if (columns.indexOf(chartSeries[key].dataSource[dsKey].category) === -1) {
                            columns.push(chartSeries[key].dataSource[dsKey].category);
                            table += "<td class='header_col'  style='background: #8bbb80' >" + chartSeries[key].dataSource[dsKey].category + "</td>";
                        }
                for (let key in chartSeries) {
                    table += "<tr><td class='header_row' >" + chartSeries[key].name + "</td>";
                    for (let c in columns)
                        for (let dsKey in chartSeries[key].dataSource)
                            if (chartSeries[key].dataSource[dsKey].category === columns[c])
                                table += '<td>' + (Number(chartSeries[key].dataSource[dsKey].value).toFixed(synData.Options.ValueAxisDecimalDigits ? synData.Options.ValueAxisDecimalDigits : undefined)).toString() + '</td>';
                }
                table += '</table>';
                $table.append(table);
                Chart.createHeader($elem);
                $table.appendTo($elem[0]);
                let HTMLTable = document.getElementById('table_' + label);
                let HTMLTableElem = HTMLTable.getElementsByTagName('table')[0];
                HTMLTableElem.style.overflow = 'auto';
                HTMLTableElem.style.display = 'block';
                HTMLTableElem.style.whiteSpace = 'normal';
                // create click handler
                let createClickHandler = (td, drillDownOption, drillDownIndex) => () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let seriesLabel = td.innerHTML;
                    if (synData[drillDownOption])
                        yield Chart.drillDownAsync($elem, seriesLabel, drillDownOption, drillDownIndex, Chart.createTableChartAsync);
                    Promise.resolve();
                });
                let cells = HTMLTable.getElementsByTagName('td');
                for (let c = 0; c < cells.length; c++) {
                    if (cells[c].className === 'header_row')
                        cells[c].onclick = createClickHandler(cells[c], 'GroupFields', 'groupFieldIndex');
                    else if (cells[c].className === 'header_col')
                        cells[c].onclick = createClickHandler(cells[c], 'CategoryAxisFields', 'categoryAxisFieldIndex');
                }
                if (synData.HelpText)
                    Chart.createHelpText($elem);
                if (synData.state.isDrillDown)
                    Chart.createResetButton($elem, Chart.createTableChartAsync);
                if (synData.Filter.UserFilterColumn && synData.Filter.HideFilterButton === false)
                    Chart.createFilterButton($elem, Chart.createTableChartAsync);
                if (synData.Options.Printable)
                    Chart.createPrintButton($elem, HTMLTable);
                return Promise.resolve();
            });
        });
    }
    static createChartAsync($elem, oldChartData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (oldChartData)
                $elem.data('synChart', $.extend({}, oldChartData));
            yield Chart.applyFilterAsync($elem).then(() => {
                const synData = $elem.data('synChart');
                let chartSeries = Chart.createSeries($elem);
                let $legend;
                let hideTickLines = (synData.Options.HideGridLines && synData.Options.HideGridLines === true) ? 0 : 1;
                let labelFormat = (synData.Options.ValueAxisDecimalDigits && synData.Options.ValueAxisDecimalDigits > 0) ?
                    ('n' + synData.Options.ValueAxisDecimalDigits.toString()).toString() : 'n';
                let chart = new ej2_charts_1.Chart({
                    series: chartSeries,
                    title: Chart.getlabelWithFilter($elem),
                    subTitle: synData.SubLabel,
                    titleStyle: { fontFamily: 'Arial', size: '24px' },
                    subTitleStyle: { fontFamily: 'Arial', size: '25px' },
                    chartArea: { border: { color: 'transparent', width: 0, } },
                    crosshair: { enable: synData.Options.Crosshair != undefined ? (synData.Options.Crosshair[0] || synData.Options.Crosshair[1]) : false },
                    zoomSettings: { enableSelectionZooming: (synData.CategoryAxisFields.length > 1) ? false : true, mode: 'X', enableScrollbar: true, toolbarItems: [] },
                    tooltip: { enable: synData.Options.Tooltip, textStyle: { fontFamily: 'Arial', size: '25px' } },
                    locale: 'de-AT',
                    legendSettings: {
                        visible: (chartSeries.length > 1 || synData.GroupFields != undefined || synData.CategoryAxisFields != undefined),
                        textStyle: { size: '25px', fontFamily: 'Arial' }
                    },
                    enableAnimation: true,
                    useGroupingSeparator: true,
                    primaryXAxis: {
                        title: synData.AxisLabels[0],
                        valueType: AxisType[synData.AxisTypes[0]],
                        crosshairTooltip: { enable: synData.Options.Crosshair ? synData.Options.Crosshair[0] : false },
                        labelStyle: { size: '25px', fontFamily: 'Arial' },
                        titleStyle: { size: '25px', fontFamily: 'Arial' },
                        visible: true,
                        majorTickLines: { width: hideTickLines },
                        minorTickLines: { width: hideTickLines },
                        majorGridLines: { width: hideTickLines },
                        minorGridLines: { width: hideTickLines }
                    },
                    primaryYAxis: {
                        title: synData.AxisLabels[1],
                        minimum: (synData.Options.ValueAxisMinimum || synData.Options.ValueAxisMinimum === 0) ? synData.Options.ValueAxisMinimum : 0,
                        maximum: (synData.Options.ValueAxisMaximum || (synData.Options.ValueAxisMaximum === 0 && synData.Options.ValueAxisMaximum > synData.Options.ValueAxisMinimum)) ? synData.Options.ValueAxisMaximum : undefined,
                        valueType: AxisType[synData.AxisTypes[1]],
                        crosshairTooltip: { enable: synData.Options.Crosshair ? synData.Options.Crosshair[1] : false },
                        labelStyle: { size: '25px', opacity: (synData.Options.DataLabel && synData.Options.DataLabel === true) ? 0 : 1, fontFamily: 'Arial' },
                        labelFormat,
                        titleStyle: { size: '25px', fontFamily: 'Arial' },
                        visible: (synData.Options.HideGridLines && synData.Options.HideGridLines === true) ? false : true,
                        majorTickLines: { width: hideTickLines },
                        minorTickLines: { width: hideTickLines },
                        majorGridLines: { width: hideTickLines },
                        minorGridLines: { width: hideTickLines }
                    },
                    chartMouseMove: (args) => {
                        let mouseleave = () => { if ($legend) {
                            $legend.style.textDecoration = 'none';
                            $legend.style.cursor = 'default';
                        } };
                        let mouseEnter = () => { $legend = document.getElementById(args.target); $legend.style.textDecoration = 'underline'; $legend.style.cursor = 'pointer'; };
                        if (args.target.indexOf('chart_legend_text') !== -1 && synData['GroupFields'][synData.state.groupFieldIndex + 1]) {
                            mouseleave();
                            mouseEnter();
                        }
                        else if (synData.CategoryAxisFields.length > 1 && args.target.indexOf('0_AxisLabel') !== -1) {
                            mouseleave();
                            mouseEnter();
                        }
                        else
                            mouseleave();
                    },
                    chartMouseClick: (args) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let labelId = args.target.split('_');
                        if (args.target.indexOf('chart_legend_text') !== -1) {
                            if (synData.GroupFields && synData['GroupFields'][synData.state.groupFieldIndex + 1]) {
                                let seriesLabel = chartSeries[labelId[labelId.length - 1]].name;
                                yield Chart.drillDownAsync($elem, seriesLabel, 'GroupFields', 'groupFieldIndex', Chart.createChartAsync);
                            }
                        }
                        else if (args.target.indexOf('0_AxisLabel') !== -1) {
                            if (synData.CategoryAxisFields.length > 1 && synData.CategoryAxisFields) {
                                let axisLabel = synData.state.axisLabelArray[labelId[labelId.length - 1]];
                                yield Chart.drillDownAsync($elem, axisLabel, 'CategoryAxisFields', 'categoryAxisFieldIndex', Chart.createChartAsync);
                            }
                        }
                    }),
                    axisLabelRender: (args) => {
                        if (args.axis.name === 'primaryXAxis' && synData.state.axisLabelArray.indexOf(args.text) === -1)
                            synData.state.axisLabelArray.push(args.text);
                    },
                    zoomComplete: () => {
                        if (!synData.state.isFiltered || !synData.state.isDrillDown)
                            Chart.createResetButton($elem, Chart.createChartAsync);
                    },
                });
                Chart.createHeader($elem);
                chart.appendTo($elem[0]);
                if (synData.HelpText)
                    Chart.createHelpText($elem);
                if (synData.state.isDrillDown)
                    Chart.createResetButton($elem, Chart.createChartAsync);
                if (synData.Filter.UserFilterColumn && synData.Filter.HideFilterButton === false)
                    Chart.createFilterButton($elem, Chart.createChartAsync);
                if (synData.Options.Printable)
                    Chart.createPrintButton($elem, chart);
                if (synData.state.isFiltered)
                    chart.title = chart.title + ' ' + synData.state.filterValue;
                return Promise.resolve();
            });
        });
    }
    static createEmptyChartAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Chart.applyFilterAsync($elem).then(() => {
                const label = Chart.getlabelWithFilter($elem);
                const noDataForFilterString = Utilities_1.synUtil.Strings.getValue('chart.noDataForFilter', 'Keine Daten für Filter');
                const $empyChart = $('<div class="emptyChart"></div>')
                    .attr({
                    'id': 'chart_emptyChart' + label,
                    'class': 'emptyChart',
                    'style': 'background-color: white; height: 315px; width: auto; font-size: 25px; border-bottom-left-radius: inherit; border-bottom-right-radius: inherit;'
                });
                $empyChart.append('<p>' + noDataForFilterString + '</p>');
                Chart.createHeader($elem, true);
                $empyChart.appendTo($elem[0]);
                return Promise.resolve();
            });
        });
    }
    static createSeries($elem) {
        const synData = $elem.data('synChart');
        let chartSeries = [];
        let data = [];
        let subDimensionNames = [];
        let roundingDigits = synData.Options.ValueAxisDecimalDigits != undefined ? Math.pow(10, synData.Options.ValueAxisDecimalDigits) : 1;
        for (let element in synData.Data) {
            let dataObject = [];
            for (let key in synData.Data[Object(element)]) {
                if (synData.Data[Object(element)].hasOwnProperty(key)) {
                    let entry = synData.Data[Object(element)][key];
                    if (entry.value == undefined && synData.Options.OmitEmptyCategory === false)
                        entry.value = 0;
                    if (entry.value)
                        entry.value = parseFloat(entry.value.toString());
                    if (entry.category === '' && synData.Options.OmitEmptyCategory === true)
                        continue;
                    // rounding if number of digits after comma is given
                    if (synData.Options.ValueAxisDecimalDigits != undefined)
                        entry.value = Math.round(entry.value * roundingDigits) / roundingDigits;
                    dataObject.push(entry);
                    subDimensionNames = [];
                    for (let property in entry)
                        subDimensionNames.push(property);
                }
                for (let item in dataObject) {
                    if (dataObject[item].value)
                        dataObject[item].value = parseFloat(dataObject[item].value);
                    if (synData.AxisTypes[0] === AxisType.DateTime)
                        dataObject[item].category = new Date(dataObject[item].category);
                    else if (synData.AxisTypes[0] === AxisType.Double)
                        dataObject[item].category = parseFloat(dataObject[item].category);
                }
                data.push(dataObject);
            }
            for (let i = 1; i < subDimensionNames.length; i++) {
                let series = {
                    type: ChartType[synData.ChartType],
                    dataSource: data[data.length - 1],
                    xName: 'category',
                    yName: subDimensionNames[i],
                    name: (subDimensionNames.length <= 2) ? element : subDimensionNames[i],
                    dataLabel: { visible: synData.Options.DataLabel ? synData.Options.DataLabel : false, font: { size: '24px' } },
                    marker: {
                        visible: (synData.Options.Marker != undefined) ? synData.Options.Marker : false,
                        width: 10,
                        height: 10,
                        border: { width: 2 },
                        dataLabel: {
                            visible: synData.Options.DataLabel ? synData.Options.DataLabel : false,
                        },
                    },
                    emptyPointSettings: synData.Options.EmptyPointMode || undefined,
                    innerRadius: '40%',
                    cornerRadius: { topLeft: 10, topRight: 10, bottomLeft: 10, bottomRight: 10 },
                    legendShape: (synData.ChartType === ChartType.Pie) ? 'Circle' : 'SeriesType'
                };
                if (synData.ChartType !== ChartType.Pyramid && synData.Groups != undefined && synData.Groups[element] != undefined) {
                    if (synData.Groups[element].Color)
                        series.fill = synData.Groups[element].Color;
                    if (synData.Groups[element].Width)
                        series.width = synData.Groups[element].Width;
                }
                chartSeries.push(series);
            }
        }
        const compareSeries = (s) => {
            return synData.DataGroupOrder.indexOf(s.name) >= 0 ? synData.DataGroupOrder.indexOf(s.name) : Number.MAX_VALUE;
        };
        if (synData.DataGroupOrder)
            chartSeries.sort((a, b) => compareSeries(a) - compareSeries(b));
        return chartSeries;
    }
    static applyFilterAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = $elem.data('synChart');
            let state = synData.state;
            let filter = state.isDrillDown ? state.drillDownfilter : state.filter;
            if (state.isDrillDown && state.isFiltered)
                filter[synData.Filter.UserFilterColumn] = synData.state.filterValue;
            Chart.destroy($elem);
            yield Chart.fetchChartDataAsync($elem, synData.chartId, true, synData.Filter, filter, synData.state.groupFieldIndex, synData.state.categoryAxisFieldIndex, synData.state.isDrillDown).then(() => {
                state.axisLabelArray = [];
                synData.state = state;
                return Promise.resolve();
            });
        });
    }
    static drillDownAsync($elem, label, field, index, done) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = $elem.data('synChart');
            synData.state.isDrillDown = true;
            if (synData[field][synData.state[index] + 1]) {
                synData.state.drillDownfilter[synData[field][synData.state[index]].FieldId] = label;
                synData.state[index] += 1;
            }
            else
                synData.state.drillDownfilter[synData[field][synData.state[index]].FieldId] = label;
            yield done($elem, synData).then(() => {
                return Promise.resolve();
            });
        });
    }
    static fetchChartDataAsync($elem, chartId, getDataFromSQL, filterOptions, filter, groupFieldIndex, categoryAxisFieldIndex, isDrillDown) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let chartInstance = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: 'POST',
                url: Utilities_1.synUtil.m_defaultWSUrlPrefix + 'Chart/' + chartId,
                requestData: JSON.stringify({
                    filter: JSON.stringify(filter),
                    groupFieldIndex: JSON.stringify(groupFieldIndex),
                    categoryAxisFieldIndex: JSON.stringify(categoryAxisFieldIndex),
                    getDataFromSQL: JSON.stringify(getDataFromSQL)
                }),
            });
            $elem.data('synChart', $.extend({}, {
                chartId: chartId,
                Label: chartInstance.Label,
                SubLabel: chartInstance.SubLabel,
                HelpText: chartInstance.HelpText,
                ChartType: chartInstance.ChartType,
                Groups: chartInstance.Groups,
                DataGroupOrder: chartInstance.DataGroupOrder,
                AxisTypes: chartInstance.AxisTypes,
                AxisLabels: chartInstance.AxisLabels,
                Data: chartInstance.Data,
                Options: {
                    Tooltip: chartInstance.Tooltip,
                    Marker: chartInstance.Marker,
                    DataLabel: chartInstance.DataLabel,
                    Crosshair: chartInstance.Crosshair,
                    ValueAxisDecimalDigits: chartInstance.ValueAxisDecimalDigits,
                    ValueAxisMinimum: chartInstance.ValueAxisMinimum,
                    ValueAxisMaximum: chartInstance.ValueAxisMaximum,
                    HideGridLines: chartInstance.HideGridLines,
                    EmptyPointMode: chartInstance.EmptyPointMode,
                    HeaderColor: chartInstance.HeaderColor,
                    HideLegend: chartInstance.HideLegend,
                    OmitEmptyCategory: (chartInstance.OmitEmptyCategory && chartInstance.OmitEmptyCategory === false) ? false : true,
                    Printable: (chartInstance.Printable && chartInstance.Printable === false) ? false : true,
                },
                Filter: {
                    UserFilterValue: filter ? filter[chartInstance.UserFilterColumn] : undefined,
                    UserFilterColumn: chartInstance.UserFilterColumn,
                    DefaultUserFilterValue: (filterOptions && filterOptions.DefaultUserFilterValue) ? filterOptions.DefaultUserFilterValue : chartInstance.DefaultUserFilterValue,
                    HideFilterButton: (chartInstance.UserFilterColumn && filterOptions && filterOptions.HideFilterButton) ? filterOptions.HideFilterButton : false,
                    DistinctFieldValues: (filterOptions && filterOptions.DistinctFieldValues) ? [...new Set(chartInstance.DistinctFieldValues.concat(filterOptions.DistinctFieldValues))] : chartInstance.DistinctFieldValues,
                },
                Gauge: {
                    Ranges: chartInstance.Ranges,
                    Minimum: chartInstance.Minimum,
                    Maximum: chartInstance.Maximum,
                    Value: chartInstance.Value,
                    Percentage: chartInstance.Percentage,
                    RadiusInPercent: chartInstance.RadiusInPercent,
                },
                GroupFields: chartInstance.GroupFields,
                CategoryAxisFields: chartInstance.CategoryAxisFields,
                state: {
                    groupFieldIndex: groupFieldIndex ? groupFieldIndex : 0,
                    categoryAxisFieldIndex: categoryAxisFieldIndex ? categoryAxisFieldIndex : 0,
                    filter: {},
                    drillDownfilter: isDrillDown ? filter : {},
                    axisLabelArray: [],
                    DistinctFieldValues: chartInstance.DistinctFieldValues,
                    isFiltered: false,
                    isDrillDown: isDrillDown != undefined ? isDrillDown : false,
                },
            }));
            const synData = $elem.data('synChart');
            // if global filter is aviable, use it. Otherwise use local filter, if aviable
            if (chartInstance.UserFilterColumn && filterOptions && filterOptions.DefaultUserFilterValue != undefined) {
                synData.state.isFiltered = true;
                synData.state.filterValue = filterOptions.DefaultUserFilterValue;
                synData.state.filter[chartInstance.UserFilterColumn] = filterOptions.DefaultUserFilterValue;
            }
            else if (chartInstance.UserFilterColumn && chartInstance.DefaultUserFilterValue) {
                synData.state.isFiltered = true;
                synData.state.filterValue = chartInstance.DefaultUserFilterValue;
                synData.state.filter[chartInstance.UserFilterColumn] = chartInstance.DefaultUserFilterValue;
            }
            return Promise.resolve();
        });
    }
    static createHeader($elem, table) {
        const synData = $elem.data('synChart');
        const headerClass = (synData.ChartType === ChartType.Table || table) ? 'headerTable' : 'headerTitle';
        const label = Chart.getlabelWithFilter($elem);
        const $header = $('<div class="headerTitle"></div>')
            .attr({
            'id': 'chart_' + synData.chartId.replace(/\|/g, '_') + '_headerTitle',
            'class': headerClass,
            'style': 'background-color: ' + (synData.Options.HeaderColor || '#8bbb80') + '; text-overflow: ellipsis; overflow:hidden; white-space:nowrap;'
        })
            .text(label);
        $header.appendTo($elem[0]);
    }
    static getlabelWithFilter($elem) {
        const synData = $elem.data('synChart');
        const hasePlaceholder = synData.Label.indexOf('%s') > -1;
        let label = synData.Label;
        if (synData.state.isFiltered && hasePlaceholder)
            label = synData.Label.replace('%s', synData.state.filterValue);
        else if (hasePlaceholder)
            label = synData.Label.replace('%s', '');
        return label;
    }
    static getRanges($elem) {
        const synData = $elem.data('synChart');
        let ranges = [];
        for (let i = 0; i < synData.Gauge.Ranges.length; i++) {
            let range = {
                legendText: synData.Gauge.Ranges[i].Label,
                color: synData.Gauge.Ranges[i].Color,
                start: synData.Gauge.Ranges[i].Start,
                end: synData.Gauge.Ranges[i].End,
                startWidth: 20,
                endWidth: 20,
            };
            ranges.push(range);
        }
        return ranges;
    }
    static createResetButton($elem, done) {
        const synData = $elem.data('synChart');
        const reset = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            Chart.destroy($elem);
            synData.state.isDrillDown = false;
            synData.state.drillDownfilter = {};
            synData.state.axisLabelArray = [];
            synData.state.groupFieldIndex = 0;
            synData.state.categoryAxisFieldIndex = 0;
            yield done($elem, synData).then(() => {
                return Promise.resolve();
            });
        });
        let resetButton = document.createElement('button');
        resetButton.id = synData.chartId;
        resetButton.innerHTML = '<i class="fa fa-refresh"> </i>';
        resetButton.classList.add('chartButton');
        resetButton.classList.add('resetButton');
        resetButton.type = 'button';
        resetButton.onclick = reset;
        if (synData.ChartType === ChartType.Table) {
            resetButton.classList.add('tableButton');
            resetButton.classList.remove('chartButton');
            $elem[0].getElementsByClassName('headerTable')[0].appendChild(resetButton);
        }
        else
            $elem[0].getElementsByClassName('headerTitle')[0].appendChild(resetButton);
    }
    static createPrintButton($elem, chart) {
        const synData = $elem.data('synChart');
        const label = Chart.getlabelWithFilter($elem);
        const print = () => {
            if (synData.ChartType === ChartType.Gauge)
                chart.export('PNG', label);
            else if (synData.ChartType === ChartType.Pie || synData.ChartType === ChartType.Pyramid)
                chart.exportModule.export('PNG', label);
            else if (synData.ChartType === ChartType.Table) {
                let tab = $('#table_' + synData.chartId)[0];
                let win = window.open('', '', 'height=700,width=700');
                win.document.write(tab.outerHTML);
                win.document.close();
                win.print();
            }
            else
                chart.exportModule.export('PNG', label);
        };
        let printButton = document.createElement('button');
        printButton.id = synData.chartId;
        printButton.innerHTML = '<i class="fa fa-print"> </i>';
        printButton.classList.add('chartButton');
        printButton.classList.add('printButton');
        printButton.type = 'button';
        printButton.onclick = print;
        if (synData.ChartType === ChartType.Table) {
            printButton.classList.add('tableButton');
            printButton.classList.remove('chartButton');
            $elem[0].getElementsByClassName('headerTable')[0].appendChild(printButton);
        }
        else
            $elem[0].getElementsByClassName('headerTitle')[0].appendChild(printButton);
    }
    static createFilterButton($elem, done) {
        const synData = $elem.data('synChart');
        const applyFilter = (value) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (value != undefined && value !== ' ') {
                synData.state.isFiltered = true;
                synData.state.filterValue = value;
                synData.state.filter[synData.Filter.UserFilterColumn] = value;
            }
            else if (value === ' ') {
                synData.state.isFiltered = false;
                synData.state.filterValue = value;
                synData.state.filter = {};
            }
            yield done($elem, synData);
            return Promise.resolve();
        });
        let ds = [];
        for (let field in synData.Filter.DistinctFieldValues)
            ds.push(synData.Filter.DistinctFieldValues[field]);
        if (synData.ChartType !== ChartType.Gauge)
            ds.push(' ');
        ds = [...new Set(ds)];
        ds.sort((a, b) => (a > b) ? 1 : -1);
        let $combo;
        if (synData.ChartType === ChartType.Table)
            $combo = $("<input class='filterCombo'></input>").appendTo($elem.find('.headerTable'));
        else
            $combo = $("<input class='filterCombo'></input>").appendTo($elem.find('.headerTitle'));
        let index = 0;
        if (synData.Filter.UserFilterValue)
            index = ds.findIndex((element) => element === synData.Filter.UserFilterValue);
        $combo.kendoComboBox({
            autoWidth: true,
            dataSource: ds,
            filter: 'contains',
            suggest: true,
            index: index,
            select: function (e) {
                applyFilter(e.dataItem);
            }
        });
    }
    static createHelpText($elem) {
        const synData = $elem.data('synChart');
        let helpButton = document.createElement("a");
        helpButton.id = synData.chartId;
        helpButton.innerHTML = '<a data-toggle="tooltip" title="' + synData.HelpText + '"><i class="fa fa-question-circle"> </i></a>';
        helpButton.classList.add('helpTextTooltip');
        if (synData.ChartType === ChartType.Table)
            $elem[0].getElementsByClassName('headerTable')[0].appendChild(helpButton);
        else
            $elem[0].getElementsByClassName('headerTitle')[0].appendChild(helpButton);
    }
}
exports.Chart = Chart;
// Dispatcher code
(($) => {
    $.fn.synChart = function (method) {
        if (Chart[method])
            return Chart[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === 'string' || !method)
            return Chart.init(this, arguments[0], arguments[1]);
        else
            $.error('Method ' + method + ' does not exist on jQuery.synChart');
    };
})(jQuery);
